const url = '/api/v1/'

// state
export const state = {
    tickets: {},
}

// getters
export const getters = {
    tickets: state => state.tickets,
}

// mutations
export const mutations = {
    setTickets(state, tickets) {
        state.tickets = tickets
    },
}

// actions
export const actions = {

    async getAll({commit, dispatch, state}) {
        dispatch('loading/addLoading', '', {root: true})
        const res = await axios.get(url + 'ticket');
        commit('setTickets', res.data)
        dispatch('loading/subLoading', '', {root: true})
        return Promise.resolve(res);
    },

    async getAllByLesson({commit, dispatch, state}, lesson_id) {
        dispatch('loading/addLoading', '', {root: true})
        const res = await axios.get(url + 'ticket/' + lesson_id);
        commit('setTickets', res.data)
        dispatch('loading/subLoading', '', {root: true})
        return Promise.resolve(res);
    },

    async create({commit, dispatch, state}, params) {
        dispatch('loading/addLoading', '', {root: true})
        const res = await axios.post(url + 'ticket', params);
        commit('setTickets', res.data)
        dispatch('loading/subLoading', '', {root: true})
        return Promise.resolve(res);
    },
}
